import * as angular from 'angular';

import { ComponentDefinition, IApplicationConfiguration, KeyValuePair } from '../../models';
import { IBulkInsertService, ICurrentApplicationService, ILoggerService } from '../../services';

class BulkInsertController implements angular.IComponentController {
    application: IApplicationConfiguration;
    errors: KeyValuePair<number, string>[];
    feedback: KeyValuePair<string, number>[];
    fileList: FileList;
    fileType: string;
    isLoading: boolean;
    loadingMessage: string;
    private _labels = ['Flat format', 'Tabular format'];

    static $inject = [
        '$scope',
        '$translate',
        'bulkInsertService',
        'currentApplicationService',
        'loggerService'
    ];

    constructor(
        private _$scope: angular.IScope,
        private _$translate: angular.translate.ITranslateService,
        private _bulkInsertService: IBulkInsertService,
        private _currentApplicationService: ICurrentApplicationService,
        private _loggerService: ILoggerService
    ) {
    }

    $onInit() {
        this.application = this._currentApplicationService.getApplicationConfiguration();

        this._$scope.$watch(() => this.fileList, () => {
            this.upload(this.fileList);
        });
    }

    upload(fileList: FileList) {
        if (fileList && fileList.length > 0) {
            this.feedback = ([] as any);
            this.fileType = null;
            this.isLoading = true;
            this._bulkInsertService
                .bulkInsert(fileList[0])
                .then(data => {
                    this._loggerService.logSuccess('Bulk insert suceeded');
                    this.errors = data.errors;
                    this.fileType = this._labels[data.fileType];
                    if (this.errors.length === 0) {
                        this.feedback.push({ key: 'Bulk insert successfully completed.', value: -1 });

                    } else {
                        this.feedback.push({ key: 'Bulk insert encountered some errors.', value: -1 });
                    }
                    this.feedback.push({ key: 'Format detected: ' + this._$translate.instant(this.fileType), value: -1 });
                    if (data.imported) {
                        Object.keys(data.imported)
                            .forEach(k => {
                                this.feedback.push({ key: k, value: data.imported[k] });
                            });
                    }
                    if (data.importedSpot) {
                        Object.keys(data.importedSpot)
                            .forEach(k => {
                                this.feedback.push({ key: k, value: data.importedSpot[k] });
                            });
                    }
                    if (this.feedback.length === 0) {
                        this.feedback.push({ key: 'No data provided.', value: -1 });
                    }
                    if (data.reprocessed > 0) {
                        this._loggerService.logSuccess(`${data.reprocessed} new reprocessing tasks launched.`, true);
                    }
                })
                .catch(reason => {
                    this._loggerService.logError('Bulk insert failed. Unknown error, please check the logs or contact an administrator.');
                })
                .finally(() => {
                    this.isLoading = false;
                });
        }
    }
}

export const bulkInsert: ComponentDefinition = {
    componentId: 'wtBulkInsert',
    controller: BulkInsertController,
    template: require('./bulkInsert.component.html'),
    controllerAs: 'vm',
    bindings: {
    }
};
